export { FroalaEditorDirective } from './editor.directive';
export { FroalaEditorModule } from './editor.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/angular-froala-wysiwyg/editor/index.js
// module id = ../../../../angular-froala-wysiwyg/editor/index.js
// module chunks = 16